import React, { useEffect, useState } from 'react';
import { FaBoxOpen  } from 'react-icons/fa';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { ProductsAnsServicesFormProps } from '../../../types/onboardingTypes';
import { BackButton, NextButton } from '../shared/Buttons';
import { Theme } from '../../../lib/theme';

const ProductsAnsServicesForm: React.FC<ProductsAnsServicesFormProps> = ({
  onContinue,
  onBack,
  initialData,
  isNextLoading,
}) => {
  
  const [productsAndServices, setProductsAndServices] = useState(initialData  || '');
  const [isAboutValid, setIsAboutValid] = useState(true);
  const country = sessionStorage.getItem('country') || 'IN'
  
  useEffect(() => {
    setProductsAndServices(initialData || '');
  
  }, [initialData]);

  const handleProductsAndServicesChange = (  e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    setProductsAndServices(value);
    setIsAboutValid(true); 
  };

 



  const handleSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    onContinue({ productsAndServices });
  };

  const isFormValid =
    (productsAndServices === '') || 
    ((productsAndServices === '' || isAboutValid) 
     );

  return (
    <div className="lg:p-0 p-2 w-full mt-[4rem] xl:mt-[2rem] 2xl:mt-[3rem] md:h-[90%] md:w-[80%] md:bg-white md:shadow-lg md:rounded-3xl md:flex md:flex-col md:items-center md:justify-between md:p-4">
      {/* Heading Section */}
        <div className="flex flex-col items-center gap-2 mb-6">
            <FaBoxOpen 
            className="text-5xl xl:text-6xl mb-2"
            style={{ color: Theme.colors.primary }}
            />
        <h1
          className="text-2xl font-bold"
          style={{ color: Theme.colors.text.strong }}
        >
          Products and Services
        </h1>
        <p className="text-sm" style={{ color: Theme.colors.text.weak }}>
         Provide Brief description of the products and services you offer.
        </p>
      </div>

      {/* Form Section */}
      <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto flex-grow flex flex-col justify-center">
        <div className="flex flex-col gap-4">
          {/* About Input */}
          <div className="flex flex-col gap-2">
            <label
              className="font-semibold"
              style={{ color: Theme.colors.text.strong }}
            >
              Products and Services
            </label>
            <textarea
              
              placeholder='Brief description of the products and services you offer.'
              className="p-3 border w-full rounded-xl min-h-[100px] lg:h-[200px] xl:h-[250px] text-start"
              style={{
                borderColor: !isAboutValid ? Theme.colors.error : Theme.colors.stroke.weak,
                outlineColor: Theme.colors.primary,
              }}
              value={productsAndServices}
              onChange={handleProductsAndServicesChange}
            />
            
          </div> 
        </div>
      </form>

      {/* Button Section */}
      <div className="lg:w-[40%] flex flex-col items-center lg:p-2 py-4 px-2 mt-auto lg:pb-20 gap-2">
        {isNextLoading ? (
          <div
            className="w-10 h-10 border-4 border-gray-300 rounded-full animate-spin"
            style={{ borderTopColor: Theme.colors.primary }}
          ></div>
        ) : productsAndServices === '' ? (
          <>
            <NextButton
              text={'Skip'}
              onClick={() => onContinue({ productsAndServices: '' })}
            />
            <BackButton onClick={onBack} />
          </>
        ) : (
          <>
            <NextButton
              text={'Continue'}
              disabled={!isAboutValid}
              onClick={handleSubmit}
            />
            <BackButton onClick={onBack} />
          </>
        )}
      </div>
    </div>
  );
};

export default ProductsAnsServicesForm;
